module.exports = {"id":"204904","name":"Moritz Bauer","rating":"75","photo":"./data/images/photos/1/204904.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["DD","DLD","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MoritzBauer0.json
// module id = 3080
// module chunks = 0